import assign from 'lodash/assign';
import * as APIS from '../../constants/api';

export const locationManagement =
  (action, payload) =>
  (dispatch, getState, { api }) =>
    api
      .post(APIS.LOCATION_MANAGEMENT, assign({ action }, payload))
      .then((result) => {
        return result;
      })
      .catch((error) => {
        throw error;
      });

export const a = 1;
